import 'moment/locale/ar';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/tr';
import 'moment/locale/pt';
import 'moment/locale/bg';
import 'moment/locale/fi';
// import 'moment/locale/hr';
